import { useEffect, useRef, useState } from "react";

import { useNavigate } from "react-router-dom";
import logoImage from "../../src/assets/logo.png";
import searchIcon from "../../src/assets/searchicon.png"; // Import the search icon
import dropdownIcon from "../../src/assets/icon.png";
import topLogo from "../../src/assets/logo-right.png";
import logofilter from "../../src/assets/filtericon.png";
import { ChevronDown, ChevronUp } from "lucide-react";
// Define types
type FilterOption = string;
type FilterState = Record<string, FilterOption[]>;

const teamSizeOptions: FilterOption[] = ["1-10", "11-50", "51-200", "201-500", "501-2000", "2001-5000", "5000+"];
const countryOptions: FilterOption[] = ["India", "Germany", "USA", "Hong Kong", "Denmark", "Netherlands", "Brazil", "UK", "Sweden", "Singapore"];
const industryOptions: FilterOption[] = ["Healthcare", "Manufacturing", "Climate Tech", "Food and Beverage Services", "Waste Management", "Clean Energy", "EV", "Software Development"];
interface Company {
  _id: string;
  name: string;
  logo?: string;
  industry: string;
  country: string;
  teamSize: string;
  fundingAmount?: string;
  inceptionYear: string;
  website?: string;
  linkedin?: string;
  description: string;
  impact: string[];
  sdg: string[];
}
interface FilterModalProps {
  isOpen: boolean;
  onClose: () => void;
  industry: string;
  setIndustry: React.Dispatch<React.SetStateAction<string>>;
  teamSize: string;
  setTeamSize: React.Dispatch<React.SetStateAction<string>>;
  country: string;
  setCountry: React.Dispatch<React.SetStateAction<string>>;
}

const FilterModal: React.FC<FilterModalProps> = ({ isOpen, onClose, industry, setIndustry, teamSize, setTeamSize, country, setCountry }) => {
  
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white w-11/12 max-w-md p-6 rounded-lg shadow-lg relative">
        {/* Close Button */}
        <button
          className="absolute top-2 right-2 text-gray-600"
          onClick={onClose}
        >
          ✖
        </button>

        <h2 className="text-xl font-bold mb-4">Filter By</h2>

         {/* Filter Dropdown 1 */}
         <div className="flex justify-between bg-gray-100 border border-gray-300 rounded-lg mb-3 p-2 items-center">
          <select
            className="w-full bg-transparent text-gray-600 focus:outline-none appearance-none cursor-pointer"
            value={industry}
            onChange={(e) => setIndustry(e.target.value)}
          >
            <option value="">Industry</option>
            <option value="Healthcare">Healthcare</option>
    <option value="Manufacturing">Manufacturing</option>
    <option value="Climate Tech">Climate Tech</option>
    <option value="Food and Beverage Services">Food and Beverage Services</option>
    <option value="Waste Management">Waste Management</option>
    <option value="Clean Energy">Clean Energy</option>
    <option value="EV">EV</option>
    <option value="Software Development">Software Development</option>
    <option value="Environmental Services">Environmental Services</option>
    <option value="Renewable Energy Equipment Manufacturing">Renewable Energy Equipment Manufacturing</option>
    <option value="Packaging">Packaging</option>
    <option value="Aviation and Aerospace Component Manufacturing">Aviation and Aerospace Component Manufacturing</option>
    <option value="Appliances, Electrical, and Electronics Manufacturing">Appliances, Electrical, and Electronics Manufacturing</option>
    <option value="Renewable Energy Power Generation">Renewable Energy Power Generation</option>
    <option value="Water Tech">Water Tech</option>
    <option value="Water Management">Water Management</option>
    <option value="Agri-Tech">Agri-Tech</option>
    <option value="Utilities">Utilities</option>
    <option value="Renewables & Environment">Renewables & Environment</option>
    <option value="Renewable Energy Semiconductor Manufacturing">Renewable Energy Semiconductor Manufacturing</option>
    <option value="Air, Water, and Waste Program Management">Air, Water, and Waste Program Management</option>
    <option value="Retail Apparel and Fashion">Retail Apparel and Fashion</option>
    <option value="Transportation, Logistics, Supply Chain and Storage">Transportation, Logistics, Supply Chain and Storage</option>
    <option value="Wholesale Building Materials">Wholesale Building Materials</option>
    <option value="Waste Treatment and Disposal">Waste Treatment and Disposal</option>
    <option value="Chemical Raw Materials Manufacturing">Chemical Raw Materials Manufacturing</option>
    <option value="Financial Services">Financial Services</option>
    <option value="Services for Renewable Energy">Services for Renewable Energy</option>
    <option value="Oil and Gas">Oil and Gas</option>
    <option value="Chemical Manufacturing">Chemical Manufacturing</option>
    <option value="Electric Power Transmission, Control, and Distribution">Electric Power Transmission, Control, and Distribution</option>
    <option value="Consumer Services">Consumer Services</option>
    <option value="Motor Vehicle Manufacturing">Motor Vehicle Manufacturing</option>
    <option value="Automotive">Automotive</option>
    <option value="Farming">Farming</option>
    <option value="Internet Marketplace Platforms">Internet Marketplace Platforms</option>
    <option value="Building Construction">Building Construction</option>
    <option value="E-Learning Providers">E-Learning Providers</option>
    <option value="Technology, Information and Internet">Technology, Information and Internet</option>
    <option value="Data Infrastructure and Analytics">Data Infrastructure and Analytics</option>
    <option value="Paper and Forest Product Manufacturing">Paper and Forest Product Manufacturing</option>
    <option value="Solar Electric Power Generation">Solar Electric Power Generation</option>
    <option value="Printing Services">Printing Services</option>
    <option value="Climate Technology Product Manufacturing">Climate Technology Product Manufacturing</option>
    <option value="Waste Collection">Waste Collection</option>
    <option value="Medical Equipment Manufacturing">Medical Equipment Manufacturing</option>
    <option value="Venture Capital and Private Equity Principals">Venture Capital and Private Equity Principals</option>
    <option value="Technology, Information and Media">Technology, Information and Media</option>
    <option value="Business Consulting and Services">Business Consulting and Services</option>
    <option value="Computer Networking">Computer Networking</option>
    <option value="Education">Education</option>
    <option value="Education Administration Programs">Education Administration Programs</option>
    <option value="Computer Hardware Manufacturing">Computer Hardware Manufacturing</option>
    <option value="Water Supply and Irrigation Systems">Water Supply and Irrigation Systems</option>
    <option value="Biotechnology">Biotechnology</option>
    <option value="Biotechnology Research">Biotechnology Research</option>
    <option value="Food Production">Food Production</option>
    <option value="Wellness and Fitness Services">Wellness and Fitness Services</option>
    <option value="Retail Health and Personal Care Products">Retail Health and Personal Care Products</option>
    <option value="Research Services">Research Services</option>
    <option value="Robotics Engineering">Robotics Engineering</option>
    <option value="Defense and Space Manufacturing">Defense and Space Manufacturing</option>
    <option value="Packaging and Containers Manufacturing">Packaging and Containers Manufacturing</option>
    <option value="Think Tanks">Think Tanks</option>
    <option value="Marketing Services">Marketing Services</option>
    <option value="IT System Custom Software Development">IT System Custom Software Development</option>
    <option value="IT Services and IT Consulting">IT Services and IT Consulting</option>
    <option value="Staffing and Recruiting">Staffing and Recruiting</option>
    <option value="Non-profit Organizations">Non-profit Organizations</option>
    <option value="Health and Human Services">Health and Human Services</option>
    <option value="Civic and Social Organizations">Civic and Social Organizations</option>
    <option value="Consumer Goods">Consumer Goods</option>
    <option value="Solar Tech">Solar Tech</option>
    <option value="Retail">Retail</option>
    <option value="Business Consulting">Business Consulting</option>
    <option value="Sustainability">Sustainability</option>
    <option value="Human Resources Service">Human Resources Service</option>
    <option value="Maritime Transportation">Maritime Transportation</option>
    <option value="Health-Tech">Health-Tech</option>
    <option value="Construction">Construction</option>
    <option value="Travel and Tourism">Travel and Tourism</option>
    <option value="Financial Service">Financial Service</option>
    <option value="Green Tech">Green Tech</option>
    <option value="Social Impact">Social Impact</option>
    <option value="Solar Energy">Solar Energy</option>
    <option value="Clean Tech">Clean Tech</option>
    <option value="AI Tech">AI Tech</option>
    <option value="Internet Publishing">Internet Publishing</option>
    <option value="Information Technology & Services">Information Technology & Services</option>
    <option value="E-Commerce">E-Commerce</option>
          </select>
          <img src={dropdownIcon} alt="Dropdown Icon" className="w-5 h-5 text-gray-400" />
        </div>

       {/* Filter Dropdown 2 */}
       <div className="flex justify-between bg-gray-100 border border-gray-300 rounded-lg mb-3 p-2 items-center">
          <select
            className="w-full bg-transparent text-gray-600 focus:outline-none appearance-none cursor-pointer"
            value={teamSize}
            onChange={(e) => setTeamSize(e.target.value)}
          >
            <option value="">Team Size</option>
            <option value="1-10">1-10</option>
            <option value="11-50">11-50</option>
            <option value="51-200">51-200</option>
            <option value="201-500">201-500</option>
            <option value="501-2000">501-2000</option>
            <option value="2001-5000">2001-5000</option>
            <option value="5000+">5000+</option>
          </select>
          <img src={dropdownIcon} alt="Dropdown Icon" className="w-5 h-5 text-gray-400" />
        </div>

        {/* Filter Dropdown 3 */}
        <div className="flex justify-between bg-gray-100 border border-gray-300 rounded-lg mb-3 p-2 items-center">
          <select
            className="w-full bg-transparent text-gray-600 focus:outline-none appearance-none cursor-pointer"
            value={country}
            onChange={(e) => setCountry(e.target.value)}
          >
            <option value="">Country</option>
            <option value="India">India</option>
        <option value="Germany">Germany</option>
        <option value="USA">USA</option>
        <option value="Hong Kong">Hong Kong</option>
        <option value="Denmark">Denmark</option>
        <option value="Netherlands">Netherlands</option>
        <option value="Brazil">Brazil</option>
        <option value="UK">UK</option>
        <option value="Sweden">Sweden</option>
        <option value="Singapore">Singapore</option>
        <option value="Australia">Australia</option>
        <option value="Canada">Canada</option>
        <option value="Austria">Austria</option>
        <option value="South Africa">South Africa</option>
        <option value="New Zealand">New Zealand</option>
        <option value="Zimbabwe">Zimbabwe</option>
        <option value="Brunei">Brunei</option>
        <option value="Kenya">Kenya</option>
          </select>
          <img src={dropdownIcon} alt="Dropdown Icon" className="w-5 h-5 text-gray-400" />
        </div>

        {/* Buttons */}
        <div className="flex justify-between mt-4">
          <button className="bg-[#002B41] text-white px-4 py-2 rounded-lg w-1/2 mr-2" onClick={onClose}>
            APPLY
          </button>
          <button className="bg-[#E6A500] text-black px-4 py-2 rounded-lg w-1/2" onClick={onClose}>
            CANCEL
          </button>
        </div>
      </div>
    </div>
  );
};


const CompanyList: React.FC = () => {
  const [companies, setCompanies] = useState<Company[]>([]);
  const [industry, setIndustry] = useState("");
  const [teamSize, setTeamSize] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [country, setCountry] = useState("");
  const dropdownRef = useRef<HTMLDivElement>(null);

  const [isFilterModalOpen, setIsFilterModalOpen] = useState(false);
  const [filters, setFilters] = useState<FilterState>({ teamSize: [], country: [], industry: [] });
  const [dropdownOpen, setDropdownOpen] = useState<Record<string, boolean>>({ teamSize: false, country: false, industry: false });

  // Toggle dropdown state
  const toggleDropdown = (filterType: "teamSize" | "country" | "industry") => {
    setDropdownOpen((prev) => {
      // If the dropdown is currently open, don't allow reopening immediately
      if (prev[filterType]) {
        return { ...prev, [filterType]: false };
      }
      // Otherwise, close all dropdowns and open the selected one
      return { teamSize: false, country: false, industry: false, [filterType]: true };
    });
  };
  

  // Handle checkbox change
  const handleCheckboxChange = (filter: keyof FilterState, value: FilterOption) => {
    setFilters((prev) => ({
      ...prev,
      [filter]: prev[filter].includes(value)
        ? prev[filter].filter((item) => item !== value)
        : [...prev[filter], value],
    }));
  };

  const [loading, setLoading] = useState(true);
  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setDropdownOpen({ teamSize: false, country: false, industry: false }); // Close all dropdowns
      }
    }
  
    // Attach the event listener
    document.addEventListener("mousedown", handleClickOutside);
  
    // Cleanup the event listener on component unmount
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  
  const navigate = useNavigate();

  useEffect(() => {
    const fetchCompanies = async () => {
      try {
        const response = await fetch("https://d2q95isnao7wof.cloudfront.net/api/companies/getallcompanies");
        const data = await response.json();
        setCompanies(data);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching companies:", error);
        setLoading(false);
      }
    };

    fetchCompanies();
  }, []);
  const filteredCompaniesMobile = companies.filter(
    (company) =>
      (industry ? company.industry === industry : true) &&
      (teamSize ? company.teamSize === teamSize : true) &&
      (searchQuery
        ? company.name.toLowerCase().includes(searchQuery.toLowerCase())
        : true) &&
      (country
        ? company.country?.toLowerCase() === country.toLowerCase()
        : true) // Case-insensitive country filter
  );

  const filteredCompanies = companies.filter((company) => {
    // Convert country name to lowercase for case-insensitive filtering
    const countryMatch =
      filters.country.length === 0 ||
      filters.country.some(
        (c) => c.toLowerCase() === company.country.toLowerCase()
      );
  
    const teamSizeMatch =
      filters.teamSize.length === 0 || filters.teamSize.includes(company.teamSize);
  
    const industryMatch =
      filters.industry.length === 0 || filters.industry.includes(company.industry);
  
    return countryMatch && teamSizeMatch && industryMatch;
  });
  
  
  
  

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-100">
        <p>Loading...</p>
      </div>
    );
  }

  return (
    <div  className="min-h-screen bg-gray-100 py-10 px-6 relative">
      {/* Logo and Filters Section */}
      <div className="w-full lg:max-w-6xl mx-auto">
        <div className="flex flex-col items-center mb-8">
          {/* Logo */}
          <div className="hidden lg:block mb-4">
            <img
              src={logoImage}
              alt="ImpactDB Logo"
              className="h-32 object-contain"
            />
          </div>
          <div className="w-full flex justify-between">
          <div className=" lg:hidden mb-4">
            <img
              src={logoImage}
              alt="ImpactDB Logo"
              className="h-24 object-contain"
            />
          </div>
        {/* Number of Companies */}
<div  className="lg:hidden flex flex-col items-center justify-start lg:gap-4 mb-8">
  <hr className="flex-grow border-gray-300" />

  {/* Simple Search Bar */}
  <div className="relative w-full max-w-xl bg-gray-100 px-4 py-3">
    {/* Input Field */}
    <input
      type="text"
      value={searchQuery}
      onChange={(e) => setSearchQuery(e.target.value)}
      className="w-full bg-gray-100 focus:outline-none text-gray-600"
    />

    {/* Icons: Filter + Search */}
    <div className="absolute top-1/2 right-0 lg:right-4 transform -translate-y-[70%] flex gap-1">
    {/* Search Icon */}
    <div className="bg-yellow-500 p-1 rounded-md cursor-pointer">
        <img src={searchIcon} alt="Search Icon" className="h-4 w-4" />
      </div>
      {/* Filter Icon */}
      <div
        className="bg-[#002B41] p-1 cursor-pointer"
        onClick={() => setIsFilterModalOpen(true)}
      >
        <img src={logofilter} alt="Filter Icon" className="h-5 w-5" />
      </div>

      
     
    </div>

    <div className="w-full h-px bg-gray-400 mt-1"></div>
  </div>

  {/* Number of Companies */}
  <span className="hidden text-xs font-light text-gray-500">
    Number of Companies found: <span className="text-black font-semibold">{filteredCompanies.length}</span>
  </span>
  <span className="lg:hidden text-xs font-light text-gray-500">
    Number of Companies found: <span className="text-black font-semibold">{filteredCompaniesMobile.length}</span>
  </span>
</div>

          </div>

         

     {/* Filters Section */}
     <div  ref={dropdownRef} className="hidden lg:block w-full bg-gray-100 py-4">
      <div className="max-w-7xl mx-auto grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3 gap-4 p-4 rounded-md shadow-md bg-white">
        
        {/* Team Size Filter */}
        <div className="relative">
          <button
            onClick={() => toggleDropdown("teamSize")}
            className="w-full p-2 text-sm flex justify-between items-center bg-gray-50 border rounded-md hover:bg-gray-100"
          >
            Filter by Team Size
            {dropdownOpen.teamSize ? <ChevronUp /> : <ChevronDown />}
          </button>
          {dropdownOpen.teamSize && (
            <div className="absolute left-0 mt-2 w-full bg-white shadow-lg border rounded-md p-2 z-50">
              {teamSizeOptions.map((size) => (
                <label key={size} className="flex items-center p-1 cursor-pointer hover:bg-gray-100 rounded-md">
                  <input
                    type="checkbox"
                    checked={filters.teamSize.includes(size)}
                    onChange={() => handleCheckboxChange("teamSize", size)}
                    className="mr-2"
                  />
                  {size}
                </label>
              ))}
            </div>
          )}
        </div>

        {/* Country Filter */}
        <div className="relative">
          <button
            onClick={() => toggleDropdown("country")}
            className="w-full p-2 text-sm flex justify-between items-center bg-gray-50 border rounded-md hover:bg-gray-100"
          >
            Filter by Country
            {dropdownOpen.country ? <ChevronUp /> : <ChevronDown />}
          </button>
          {dropdownOpen.country && (
            <div className="absolute left-0 mt-2 w-full bg-white shadow-lg border rounded-md p-2 z-50 ">
              {countryOptions.map((c) => (
                <label key={c} className="flex items-center p-1 cursor-pointer hover:bg-gray-100 rounded-md">
                  <input
                    type="checkbox"
                    checked={filters.country.includes(c)}
                    onChange={() => handleCheckboxChange("country", c)}
                    className="mr-2"
                  />
                  {c}
                </label>
              ))}
            </div>
          )}
        </div>

        {/* Industry Filter */}
        <div className="relative">
          <button
            onClick={() => toggleDropdown("industry")}
            className="w-full p-2 text-sm flex justify-between items-center bg-gray-50 border rounded-md hover:bg-gray-100"
          >
            Filter by Industry
            {dropdownOpen.industry ? <ChevronUp /> : <ChevronDown />}
          </button>
          {dropdownOpen.industry && (
            <div className="absolute left-0 mt-2 w-full bg-white shadow-lg border rounded-md p-2 z-50 ">
              {industryOptions.map((ind) => (
                <label key={ind} className="flex items-center p-1 cursor-pointer hover:bg-gray-100 rounded-md">
                  <input
                    type="checkbox"
                    checked={filters.industry.includes(ind)}
                    onChange={() => handleCheckboxChange("industry", ind)}
                    className="mr-2"
                  />
                  {ind}
                </label>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>

        </div>

        {/* Number of Companies */}
        <div className="hidden lg:flex flex-col items-center justify-center gap-4 mb-8">
          <hr className="flex-grow border-gray-300" />
      {/* Simple Search Bar */}
<div className="relative w-full max-w-xl  bg-gray-100 px-4 py-3 ">
  <input
    type="text"
    value={searchQuery}
    onChange={(e) => setSearchQuery(e.target.value)}
    className="w-full bg-gray-100 focus:outline-none text-gray-600"
  />
        <div
              className="absolute top-1/2 right-4 transform -translate-y-[70%] bg-yellow-500 p-2  rounded-md cursor-pointer"
              
            >
              <img src={searchIcon} alt="Search Icon" className="h-5 w-5" />
            </div>
            <div className="w-full h-px bg-gray-400 mt-1"></div>
</div>

        
          <span className="hidden lg:block text-base font-normal text-gray-500">
            Number of Companies found: <span className="text-black font-semibold">{filteredCompanies.length}</span>
          </span>
          <span className="lg:hidden text-base font-normal text-gray-500">
            Number of Companies found: <span className="text-black font-semibold">{filteredCompaniesMobile.length}</span>
          </span>
        </div>
      </div>

      {/* Companies Grid */}
      <div className="hidden max-w-6xl mx-auto lg:grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-8">
        {filteredCompanies.map((company) => (
          <div
            key={company._id}
            className="bg-white shadow-lg rounded-xl overflow-hidden flex hover:shadow-2xl transition-all duration-200"
          >
           {/* Company Logo */}
<div className="bg-white p-4 flex items-center justify-center w-1/3">
  {company.logo ? (
    <img
      src={company.logo}
     
      className="h-28 w-28 object-contain aspect-auto p-2 bg-white"
      onError={(e) => (e.currentTarget.src = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mP8/wcAAgAB/ntTVW8AAAAASUVORK5CYII=")}

    />
  ) : (
    <div className="h-28 w-28 bg-white flex items-center justify-center">
      {/* Fallback white background */}
      <img
        src="https://via.placeholder.com/150/FFFFFF/FFFFFF
"
onError={(e) => (e.currentTarget.src = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mP8/wcAAgAB/ntTVW8AAAAASUVORK5CYII=")}

     
        className="h-28 w-28 object-contain aspect-auto p-2 bg-white"
      />
    </div>
  )}
</div>


            {/* Company Details */}
            <div className="relative p-6 w-2/3 flex flex-col justify-between">
                            {/* Logo-Right Container */}
  <div
    className="absolute top-4 right-4 bg-[#E6A500] flex items-center justify-center rounded-md p-2 cursor-pointer"
    onClick={() => navigate(`/company/${company._id}`)} // Navigate to the detailed page
  >
    <img
      src={topLogo} // Replace this with the actual logo file path
      alt="Company Logo"
      className="h-4 w-4 object-contain"
    />
  </div>
              <div className="px-2">
                <h3 className="text-2xl font-bold text-gray-800 mb-2">
                  {company.name}
                </h3>
                <p className="text-sm text-gray-600 font-extrabold mb-1">
                  <span className="font-medium">Industry:</span> {company.industry}
                </p>
                <p className="text-sm text-gray-600 font-extrabold mb-1">
                  <span className="font-medium">Country:</span> {company.country}
                </p>
              </div>

              <div className="mt-4 grid grid-cols-3 gap-8 text-sm text-gray-600 bg-gray-100 rounded-md p-2">
                <div>
                  <p className="font-medium">Funding Amount</p>
                  <p className="font-bold">{company.fundingAmount || "N/A"}</p>
                </div>
                <div>
                  <p className="font-medium">Inception (Year)</p>
                  <p className="font-bold">{company.inceptionYear}</p>
                </div>
                <div>
                  <p className="font-medium">Team <br/>Size</p>
                  <p className="font-bold">{company.teamSize}</p>
                </div>
              </div>
            </div>

          
          </div>
        ))}
      </div>
      <div className="lg:hidden max-w-6xl mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-8">
        {filteredCompaniesMobile.map((company) => (
          <div
            key={company._id}
            className="bg-white shadow-lg rounded-xl overflow-hidden flex hover:shadow-2xl transition-all duration-200"
          >
           {/* Company Logo */}
<div className="bg-white p-4 flex items-center justify-center w-1/3">
  {company.logo ? (
    <img
      src={company.logo}
     
      className="h-28 w-28 object-contain aspect-auto p-2 bg-white"
      onError={(e) => (e.currentTarget.src = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mP8/wcAAgAB/ntTVW8AAAAASUVORK5CYII=")}

    />
  ) : (
    <div className="h-28 w-28 bg-white flex items-center justify-center">
      {/* Fallback white background */}
      <img
        src="https://via.placeholder.com/150/FFFFFF/FFFFFF
"
onError={(e) => (e.currentTarget.src = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mP8/wcAAgAB/ntTVW8AAAAASUVORK5CYII=")}

     
        className="h-28 w-28 object-contain aspect-auto p-2 bg-white"
      />
    </div>
  )}
</div>


            {/* Company Details */}
            <div className="relative p-6 w-2/3 flex flex-col justify-between">
                            {/* Logo-Right Container */}
  <div
    className="absolute top-4 right-4 bg-[#E6A500] flex items-center justify-center rounded-md p-2 cursor-pointer"
    onClick={() => navigate(`/company/${company._id}`)} // Navigate to the detailed page
  >
    <img
      src={topLogo} // Replace this with the actual logo file path
      alt="Company Logo"
      className="h-4 w-4 object-contain"
    />
  </div>
              <div className="px-2">
                <h3 className="text-2xl font-bold text-gray-800 mb-2">
                  {company.name}
                </h3>
                <p className="text-sm text-gray-600 font-extrabold mb-1">
                  <span className="font-medium">Industry:</span> {company.industry}
                </p>
                <p className="text-sm text-gray-600 font-extrabold mb-1">
                  <span className="font-medium">Country:</span> {company.country}
                </p>
              </div>

              <div className="mt-4 grid grid-cols-3 gap-8 text-sm text-gray-600 bg-gray-100 rounded-md p-2">
                <div>
                  <p className="font-medium">Funding Amount</p>
                  <p className="font-bold">{company.fundingAmount || "N/A"}</p>
                </div>
                <div>
                  <p className="font-medium">Inception (Year)</p>
                  <p className="font-bold">{company.inceptionYear}</p>
                </div>
                <div>
                  <p className="font-medium">Team <br/>Size</p>
                  <p className="font-bold">{company.teamSize}</p>
                </div>
              </div>
            </div>

          
          </div>
        ))}
      </div>
      
      <FilterModal 
        isOpen={isFilterModalOpen} 
        onClose={() => setIsFilterModalOpen(false)} 
        industry={industry} 
        setIndustry={setIndustry} 
        teamSize={teamSize} 
        setTeamSize={setTeamSize} 
        country={country} 
        setCountry={setCountry} 
      />

    </div>
  );
};

export default CompanyList;
